export function cutText(text, quantityCharacters) {
  if (text?.length > quantityCharacters) {
    return text.slice(0, quantityCharacters) + "...";
  } else {
    return text;
  }
}
